import React, { FC, Fragment, useState } from 'react';
import classNames from 'classnames';
import { EditorState } from 'draft-js';
import EditorUtils from 'draft-js-plugins-utils';

import { CustomSVG } from 'components';

import { getSelectedEntityData, getSelection, isCollapsed } from '../../utilities';
import { ILink, IToolbarPluginRenderProps } from '../../types';
import { LINK_ENTITY_NAME } from '../../constants';

import LinkForm from './LinkForm';

const LinkButton: FC<IToolbarPluginRenderProps> = props => {
  const { theme, getEditorState, setEditorState } = props;

  const [open, setOpen] = useState(false);
  const [selectionState, setSelectionState] = useState(getSelection(getEditorState()));

  const isSelected = EditorUtils.hasEntity(getEditorState(), LINK_ENTITY_NAME);
  const isDisabled = isCollapsed(getEditorState());
  const initialValues = getValues();

  const buttonClasses = classNames(theme.button, {
    [theme.active]: isSelected,
  });

  function getValues() {
    const entityData = getSelectedEntityData(getEditorState());
    return entityData || { url: '' };
  }

  function handleAddLink() {
    setSelectionState(getEditorState().getSelection());
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
    setEditorState(EditorState.forceSelection(getEditorState(), selectionState));
  }

  function handleRemoveLink() {
    setEditorState(EditorUtils.removeLinkAtSelection(getEditorState()));
    setOpen(false);
  }

  function handleSave(changedValues: ILink) {
    setEditorState(EditorUtils.createLinkAtSelection(getEditorState(), changedValues.url));
    handleClose();
  }

  return (
    <Fragment>
      <LinkForm
        open={open}
        initialValues={initialValues}
        onClose={handleClose}
        onSave={handleSave}
        onRemove={handleRemoveLink}
      />
      <div className={theme.buttonWrapper}>
        <button
          disabled={isDisabled}
          type="button"
          className={buttonClasses}
          onClick={handleAddLink}>
          <CustomSVG name="link" />
        </button>
      </div>
    </Fragment>
  );
};

export default LinkButton;
